module.exports = __webpack_public_path__ + "static/PierSans-Regular-573a45d755465e0a78a6a4eda91046c1.otf";